const userObjectReducer = (state = null, action) => {
  switch (action.type) {
    case 'FETCH_USER_OBJECT':{
      return{
      ...state,
      details:  action.payload}
      break;
    }
  }
  return state;
}

export default userObjectReducer;
